import React from 'react';

import useModal from 'hooks/useModal';
import { useTarget } from 'providers/target/useTarget';
import { IButtonContentsModule } from 'types';
import LinkSelector from './LinkSelector';

interface Props {
  module: IButtonContentsModule;
}

function EditButton({ module }: Props) {
  const { handleModal } = useModal();
  const { targetList, setTargetList } = useTarget();

  const label = module.data;
  const link = module.link;

  const handleSelect = (next: { label: string; link: string }) => {
    const trimmedLabel = next.label.trim();
    const trimmedLink = next.link.trim();

    setTargetList(
      targetList.map((i) => {
        if (i.id === module.id) {
          return { ...i, data: trimmedLabel, link: trimmedLink };
        }
        return i;
      }),
    );
  };

  const handleClick = () => {
    handleModal(
      '버튼 설정',
      <LinkSelector
        initialLabel={label}
        initialUrl={link}
        handleSelect={handleSelect}
      />,
    );
  };

  const hasConfig = Boolean(label || link);
  const displayLabel =
    label || (link ? '버튼' : '버튼 (클릭해서 설정해주세요)');

  return (
    <div
      css={{
        display: 'flex',
        justifyContent: 'center',
        margin: '16px 0',
      }}
    >
      <button
        type="button"
        onClick={handleClick}
        title={hasConfig ? link : '클릭해서 버튼을 설정해주세요'}
        css={{
          cursor: 'pointer',
          background: '#fff',
          color: '#222',
          border: '1px solid #d9d9d9',
          borderRadius: '8px',
          padding: '9px 16px',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 1.4,
          minWidth: '220px',
          textAlign: 'center',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
          transition: 'opacity 0.1s ease-out',
          '&:hover': {
            opacity: 0.7,
          },
        }}
      >
        {displayLabel}
      </button>
    </div>
  );
}

export default EditButton;
